export interface State {
    sidebar: {
        isCollapse: boolean
    }
}

const state: State = {
    sidebar: {
        isCollapse: false // 导航栏默认展开
    }
}

const mutations = {
    setIsCollapse: (state: State, payload: boolean) => {
        state.sidebar.isCollapse = payload
    }
}

export default {
    namespaced: true,
    state,
    mutations
}
